const appEnvs = ['develop', 'staging', 'prod', 'bi', 'qav2'];
export const ensureAppEnv = value => {
  if (!value) {
    throw new Error("Environment variable REACT_APP_BUZZENV is not set. It should be one of ".concat(appEnvs.join(', ')));
  }
  if (!appEnvs.includes(value)) {
    throw new Error("Environment variable REACT_APP_BUZZENV is invalid. Received: ".concat(value, ". It should be one of ").concat(appEnvs.join(', ')));
  }
};